import card_facebook from '/assets/integration/cards/facebook.svg';
import card_google_calendar from '/assets/integration/cards/google-calendar.svg';
import card_instagram from '/assets/integration/cards/instagram.svg';
import card_linkedin from '/assets/integration/cards/linkedin.svg';
import card_meta from '/assets/integration/cards/meta.svg';
import card_petpooja from '/assets/integration/cards/petpooja.svg';
import card_shopify from '/assets/integration/cards/shopify.svg';
import card_tiktok from '/assets/integration/cards/tiktok.svg';
import card_woocommerce from '/assets/integration/cards/woocommerce.svg';
import card_youtube from '/assets/integration/cards/youtube.svg';
import card_zoom from '/assets/integration/cards/zoom.svg';
import { cn } from '@/lib/utils';

export const INTEGRATION_TILE_ICONS: Record<string, string> = {
  instagram: card_instagram,
  facebook: card_facebook,
  linkedin: card_linkedin,
  youtube: card_youtube,
  tiktok: card_tiktok,
  shopify: card_shopify,
  woocommerce: card_woocommerce,
  petpooja: card_petpooja,
  whatsapp_catalog: card_meta,
  meta_ads: card_meta,
  google_calendar: card_google_calendar,
  zoom: card_zoom,
};

export function IntegrationTileIcon({
  src,
  className = 'h-8 w-8',
}: {
  src: string;
  className?: string;
}) {
  return <img src={src} alt="" aria-hidden className={cn('shrink-0 object-contain', className)} />;
}
